﻿import {
    FETCH_FAQ_QUESTIONS_STARTED,
    FETCH_FAQ_QUESTIONS_COMPLETED
} from './actions';

const initialState = {
    loading: false,
    categories: [],
    fAQQuestions: [],
    error: null
};

export const faqData = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_FAQ_QUESTIONS_STARTED:
            return {
                ...state,
                loading: true,
                error: null 
            };
        case FETCH_FAQ_QUESTIONS_COMPLETED:
            return {
                ...state,
                loading: false,
                categories: action.payload.categories,
                fAQQuestions: action.payload.fAQQuestions,
                error: null
            };
        default:
            return state;
    }
}
